import { CAPTURE_SESSION_STORAGE_KEY, RECORDING_TAB_STORAGE_KEY } from 'constants';

export const getCaptureSessionId = () => {
  try {
    let sessionId = localStorage.getItem(CAPTURE_SESSION_STORAGE_KEY);
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      localStorage.setItem(CAPTURE_SESSION_STORAGE_KEY, sessionId);
    }
    return sessionId;
  } catch (err) {
    return crypto.randomUUID();
  }
};

export const getRecordingTabId = () => {
  try {
    let tabId = sessionStorage.getItem(RECORDING_TAB_STORAGE_KEY);
    if (!tabId) {
      tabId = crypto.randomUUID();
      sessionStorage.setItem(RECORDING_TAB_STORAGE_KEY, tabId);
    }
    return tabId;
  } catch (err) {
    return crypto.randomUUID();
  }
};

export const supportsDisplayCapture = () => {
  return typeof navigator !== 'undefined'
    && navigator.mediaDevices
    && typeof navigator.mediaDevices.getDisplayMedia === 'function';
};
